import Promise from "bluebird";
import JsZip from "jszip";
import FileSaver from "file-saver";

const getFileExtFromUrl = (url) => {
  const urlObj = new URL(url);
  return urlObj.pathname.split(".").pop();
};

const downloadToBlob = (url) => {
  return fetch(url).then((resp) => resp.blob());
};

export const downloadByGroup = (urlObj, filesPerGroup = 5) => {
  return Promise.map(
    urlObj,
    async (urlObj) => {
      const blob = await downloadToBlob(urlObj.downloadUrl);
      return { ...urlObj, blob };
    },
    { concurrency: filesPerGroup }
  );
};

export const exportZip = (blobObj, fileName) => {
  const zip = JsZip();
  const timestamp = Date.now();
  blobObj.forEach((blobItem, i) => {
    zip.file(
      `${blobItem.name || timestamp}.${getFileExtFromUrl(
        blobItem.downloadUrl
      )}`,
      blobItem.blob
    );
  });
  zip.generateAsync({ type: "blob" }).then((zipFile) => {
    return FileSaver.saveAs(zipFile, `${fileName}.zip`);
  });
};

export const downloadByZip = (fileObj, name) => {
  return downloadByGroup(fileObj).then((res) => {
    exportZip(res, name);
  });
};

export const downloadByFile = (path, name) => {
  const xhr = new XMLHttpRequest();
  xhr.open("get", path);
  xhr.responseType = "blob";
  xhr.send();
  xhr.onload = function () {
    if (this.status === 200 || this.status === 304) {
      // 如果是IE10及以上，不支持download属性，采用msSaveOrOpenBlob方法，但是IE10以下也不支持msSaveOrOpenBlob
      if ("msSaveOrOpenBlob" in navigator) {
        navigator.msSaveOrOpenBlob(this.response, name);
        return;
      }
      const url = URL.createObjectURL(this.response);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };
};
